import CheckboxField from "@/components/form/CheckboxField"
import CurrencyField from "@/components/form/CurrencyField"
import DateField from "@/components/form/DateField"
import DynamicPhoneField from "@/components/form/DynamicPhoneField"
import EmailField from "@/components/form/EmailField"
import NumberField from "@/components/form/NumberField"
import PhoneField from "@/components/form/PhoneField"
import SelectField from "@/components/form/SelectField"
import SsnField from "@/components/form/SsnField"
import TextField from "@/components/form/TextField"
import ZipCodeField from "@/components/form/ZipCodeField"
import StateField from "@/components/form/StateField"
import RadioField from "@/components/form/RadioField"

const descriptorByType = {
    checkbox: {
        component: CheckboxField,
    },

    currency: {
        component: CurrencyField,
    },

    date: {
        component: DateField,
    },

    dynamicPhone: {
        component: DynamicPhoneField
    },

    email: {
        component: EmailField,
    },

    number: {
        component: NumberField,
    },

    phone: {
        component: PhoneField,
    },

    radio: {
        component: RadioField
    },

    select: {
        component: SelectField,
    },

    state: {
        component: StateField,
    },

    ssn: {
        component: SsnField,
    },

    text: {
        component: TextField,
    },

    zipCode: {
        component: ZipCodeField,
    },
}

export const getFieldDescriptor = function(config) {
    let descriptor = descriptorByType[config.type]
    if (!descriptor) {
        console.warn("No descriptor for type: " + config.type)
        descriptor = descriptorByType["text"]
    }
    return descriptor
}
